import { render, staticRenderFns } from "./footBar.vue?vue&type=template&id=583b1e3e&"
import script from "./footBar.vue?vue&type=script&lang=js&"
export * from "./footBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports